/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import type {
  PerpetualMarket,
  PerpetualMarketInterface
} from '../PerpetualMarket'

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_perpetualMarketCoreAddress',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_quoteAsset',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_underlyingAsset',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_feeRecepient',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_vaultNFT',
        type: 'address'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'issued',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'Deposited',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'trader',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'vaultId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'DepositedToVault',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'hedger',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'isBuyingUnderlying',
        type: 'bool'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'usdcAmount',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'underlyingAmount',
        type: 'uint256'
      }
    ],
    name: 'Hedged',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'liquidator',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'vaultId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'reward',
        type: 'uint256'
      }
    ],
    name: 'Liquidated',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'OwnershipTransferred',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'trader',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'vaultId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'subVaultIndex',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'productId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'tradeAmount',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'tradePrice',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'fundingFeePerPosition',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'deltaUsdcPosition',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'bytes',
        name: 'metadata',
        type: 'bytes'
      }
    ],
    name: 'PositionUpdated',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'feeRecepient',
        type: 'address'
      }
    ],
    name: 'SetFeeRecepient',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'burned',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'Withdrawn',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'trader',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'vaultId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'WithdrawnFromVault',
    type: 'event'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      },
      {
        internalType: 'int256',
        name: '_marginToAdd',
        type: 'int256'
      }
    ],
    name: 'addMargin',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_depositAmount',
        type: 'uint256'
      }
    ],
    name: 'deposit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'execHedge',
    outputs: [
      {
        internalType: 'uint256',
        name: 'amountUsdc',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'amountUnderlying',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'feeRecepient',
    outputs: [
      {
        internalType: 'contract IFeePool',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: '_deltaLiquidityAmount',
        type: 'int256'
      }
    ],
    name: 'getLPTokenPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      },
      {
        internalType: 'int128[2]',
        name: '_tradeAmounts',
        type: 'int128[2]'
      }
    ],
    name: 'getMinCollateralToAddPosition',
    outputs: [
      {
        internalType: 'int256',
        name: 'minCollateral',
        type: 'int256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getTokenAmountForHedging',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_productId',
        type: 'uint256'
      },
      {
        internalType: 'int128',
        name: '_tradeAmount',
        type: 'int128'
      }
    ],
    name: 'getTradePrice',
    outputs: [
      {
        components: [
          {
            internalType: 'int256',
            name: 'tradePrice',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'indexPrice',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'fundingRate',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'tradeFee',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'protocolFee',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'fundingFee',
            type: 'int256'
          },
          {
            internalType: 'uint256',
            name: 'totalValue',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'totalFee',
            type: 'uint256'
          }
        ],
        internalType: 'struct IPerpetualMarket.TradeInfo',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      }
    ],
    name: 'getTraderVault',
    outputs: [
      {
        components: [
          {
            internalType: 'int128',
            name: 'positionUsdc',
            type: 'int128'
          },
          {
            components: [
              {
                internalType: 'int128[2]',
                name: 'positionPerpetuals',
                type: 'int128[2]'
              },
              {
                internalType: 'uint128[2]',
                name: 'entryPrices',
                type: 'uint128[2]'
              },
              {
                internalType: 'int256[2]',
                name: 'entryFundingFee',
                type: 'int256[2]'
              }
            ],
            internalType: 'struct TraderVaultLib.SubVault[]',
            name: 'subVaults',
            type: 'tuple[]'
          },
          {
            internalType: 'bool',
            name: 'isInsolvent',
            type: 'bool'
          }
        ],
        internalType: 'struct TraderVaultLib.TraderVault',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      }
    ],
    name: 'getVaultStatus',
    outputs: [
      {
        components: [
          {
            internalType: 'int256',
            name: 'positionValue',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'minCollateral',
            type: 'int256'
          },
          {
            internalType: 'int256[2][]',
            name: 'positionValues',
            type: 'int256[2][]'
          },
          {
            internalType: 'int256[2][]',
            name: 'fundingPaid',
            type: 'int256[2][]'
          },
          {
            components: [
              {
                internalType: 'int128',
                name: 'positionUsdc',
                type: 'int128'
              },
              {
                components: [
                  {
                    internalType: 'int128[2]',
                    name: 'positionPerpetuals',
                    type: 'int128[2]'
                  },
                  {
                    internalType: 'uint128[2]',
                    name: 'entryPrices',
                    type: 'uint128[2]'
                  },
                  {
                    internalType: 'int256[2]',
                    name: 'entryFundingFee',
                    type: 'int256[2]'
                  }
                ],
                internalType: 'struct TraderVaultLib.SubVault[]',
                name: 'subVaults',
                type: 'tuple[]'
              },
              {
                internalType: 'bool',
                name: 'isInsolvent',
                type: 'bool'
              }
            ],
            internalType: 'struct TraderVaultLib.TraderVault',
            name: 'rawVaultData',
            type: 'tuple'
          }
        ],
        internalType: 'struct IPerpetualMarket.VaultStatus',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'hedger',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_depositAmount',
        type: 'uint256'
      },
      {
        internalType: 'int256',
        name: '_initialFundingRate',
        type: 'int256'
      }
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      }
    ],
    name: 'liquidateByPool',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'quoteAsset',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_feeRecepient',
        type: 'address'
      }
    ],
    name: 'setFeeRecepient',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_hedger',
        type: 'address'
      }
    ],
    name: 'setHedger',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'vaultId',
            type: 'uint256'
          },
          {
            components: [
              {
                internalType: 'uint256',
                name: 'productId',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'subVaultIndex',
                type: 'uint256'
              },
              {
                internalType: 'int128',
                name: 'tradeAmount',
                type: 'int128'
              },
              {
                internalType: 'uint256',
                name: 'limitPrice',
                type: 'uint256'
              },
              {
                internalType: 'bytes',
                name: 'metadata',
                type: 'bytes'
              }
            ],
            internalType: 'struct IPerpetualMarket.TradeParams[]',
            name: 'trades',
            type: 'tuple[]'
          },
          {
            internalType: 'int256',
            name: 'marginAmount',
            type: 'int256'
          },
          {
            internalType: 'uint256',
            name: 'deadline',
            type: 'uint256'
          }
        ],
        internalType: 'struct IPerpetualMarket.MultiTradeParams',
        name: '_tradeParams',
        type: 'tuple'
      }
    ],
    name: 'trade',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'underlyingAsset',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint128',
        name: '_withdrawnAmount',
        type: 'uint128'
      }
    ],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  }
]

const _bytecode =
  '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$b139f62619843504e83620ab3c72958bdd$__906369e2bed090610e9d8460646130dc565b6040518363ffffffff1660e01b8152600401610eba929190614683565b60006040518083038186803b158015610ed257600080fd5b505af4158015610ee6573d6000803e3d6000fd5b505050506000610ef582613185565b9050610f2c6001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016333084612eb7565b336001600160a01b03167ffc3608744ea5805574f007540fe37736bbebd81365de55991f3b17a16295521d8483604051610f67929190614683565b60405180910390a2505050565b610f7c612dfa565b6001600160a01b0316610f8d611205565b6001600160a01b031614610fd6576040805162461bcd60e51b8152602060048201819052602482015260008051602061497e833981519152604482015290519081900360640190fd5b600080546040516001600160a01b03909116907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908390a3600080546001600160a01b0319169055565b7f000000000000000000000000000000000000000000000000000000000000000081565b6040516339f9a44f60e11b81526000906001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016906373f3489e90611093908590600401614523565b60206040518083038186803b1580156110ab57600080fd5b505afa1580156110bf573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906110e39190613f4a565b92915050565b6000806000807f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663854ad1b76040518163ffffffff1660e01b815260040160806040518083038186803b15801561114857600080fd5b505afa15801561115c573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906111809190613fa1565b90508060600151606482600001518161119557fe5b046111f9836020015160087f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663313ce5676040518163ffffffff1660e01b815260040160206040518083038186803b15801561089c57600080fd5b93509350935050909192565b6000546001600160a01b031690565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316637d8c26596040518163ffffffff1660e01b8152600401600060405180830381600087803b15801561126f57600080fd5b505af1158015611283573d6000803e3d6000fd5b505050600082815260046020908152604080832081516060810183528154600f90810b810b900b81526001820180548451818702810187019095528085529296506001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016946382f3955d94611447948993858401939091908a9084015b82821015611429576000848152602090206040805160a0810190915290600484020181606081018260028282826020028201916000905b82829054906101000a9004600f0b600f0b81526020019060100190602082600f0104928301926001038202915080841161133e575050509284525050604080518082019182905260209093019291506001840190600290826000855b82829054906101000a90046001600160801b03166001600160801b031681526020019060100190602082600f0104928301926001038202915080841161139a5750505092845250506040805180820191829052602090930192915060028481019182845b8154815260200190600101908083116113fe5750505050508152505081526020019060010190611307565b505050908252506002919091015460ff161515602090910152612f4b565b6040518263ffffffff1660e01b815260040161146391906144fd565b60e06040518083038186803b15801561147b57600080fd5b505afa15801561148f573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906114b3919061416d565b604080516060810182528454600f90810b810b900b81526001850180548351602082810282018101909552818152949550611639948694889381860193909160009084015b8282101561161a576000848152602090206040805160a0810190915290600484020181606081018260028282826020028201916000905b82829054906101000a9004600f0b600f0b81526020019060100190602082600f0104928301926001038202915080841161152f575050509284525050604080518082019182905260209093019291506001840190600290826000855b82829054906101000a90046001600160801b03166001600160801b031681526020019060100190602082600f0104928301926001038202915080841161158b5750505092845250506040805180820191829052602090930192915060028481019182845b8154815260200190600101908083116115ef57505050505081525050815260200190600101906114f8565b505050908252506002919091015460ff161515602090910152906131e0565b6116555760405162461bcd60e51b815260040161054790614566565b60006117ea82846040518060600160405290816000820160009054906101000a9004600f0b600f0b600f0b815260200160018201805480602002602001604051908101604052809291908181526020016000905b828210156117cb576000848152602090206040805160a0810190915290600484020181606081018260028282826020028201916000905b82829054906101000a9004600f0b600f0b81526020019060100190602082600f010492830192600103820291508084116116e0575050509284525050604080518082019182905260209093019291506001840190600290826000855b82829054906101000a90046001600160801b03166001600160801b031681526020019060100190602082600f0104928301926001038202915080841161173c5750505092845250506040805180820191829052602090930192915060028481019182845b8154815260200190600101908083116117a057505050505081525050815260200190600101906116a9565b505050908252506002919091015460ff161515602090910152906130bc565b90506000805b60018501548110156118905760005b600281101561188757600086600101838154811061181957fe5b9060005260206000209060040201600001826002811061183557fe5b600291828204019190066010029054906101000a9004600f0b905061187c61187588848b8786600003600060405180602001604052806000815250613201565b85906133ea565b9350506001016117ff565b506001016117f0565b50604051630de022c160e11b815273__$b139f62619843504e83620ab3c72958bdd$__90631bc04582906118c8908790600401614523565b60006040518083038186803b1580156118e057600080fd5b505af41580156118f4573d6000803e3d6000fd5b505060405163652aa48360e01b81526000925073__$b139f62619843504e83620ab3c72958bdd$__915063652aa4839061193890889087906107d090600401614691565b60206040518083038186803b15801561195057600080fd5b505af4158015611964573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906119889190613f4a565b6040516328e32c8560e11b81529091507f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316906351c6590a906119da906002850490600401614523565b600060405180830381600087803b1580156119f457600080fd5b505af1158015611a08573d6000803e3d6000fd5b50505050611a203360c88381611a1a57fe5b04612dc2565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166387c3a09a6040518163ffffffff1660e01b8152600401600060405180830381600087803b158015611a7b57600080fd5b505af1158015611a8f573d6000803e3d6000fd5b505050506000821115611ba95760025460405163095ea7b360e01b81526001600160a01b037f000000000000000000000000000000000000000000000000000000000000000081169263095ea7b392611af192919091169086906004016144c3565b602060405180830381600087803b158015611b0b57600080fd5b505af1158015611b1f573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611b439190613f18565b506002546040516301acfa2360e51b81526001600160a01b039091169063359f446090611b7690309086906004016144c3565b600060405180830381600087803b158015611b9057600080fd5b505af1158015611ba4573d6000803e3d6000fd5b505050505b857f09c223cfcd8c93e245f558f5f8de755fc0930fd9bc257441155ef5d54a170e0f3383604051611bdb9291906144c3565b60405180910390a2505050505050565b600082118015611bfb5750600081135b611c0457600080fd5b60405163e7dc45d360e01b81526000906001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000169063e7dc45d390611c5a903390606488029087906004016144dc565b602060405180830381600087803b158015611c7457600080fd5b505af1158015611c88573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611cac9190613f4a565b9050611ce36001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016333086612eb7565b336001600160a01b03167f73a19dd210f1a7f902193214c0ee91dd35ee5b4d920cba8d519eca65a7b488ca8285604051610f67929190614683565b611d26613d7f565b60008060008060007f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663b4f0332f89896040518363ffffffff1660e01b8152600401611d7c92919061479e565b60a06040518083038186803b158015611d9457600080fd5b505afa158015611da8573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611dcc9190613f62565b94509450945094509450604051806101000160405280868152602001858152602001848152602001838152602001828152602001611e24662386f26fc10000611e1e87896130dc90919063ffffffff16565b90613444565b8152602001611e556305f5e100611e4f611e408c600f0b6134fc565b611e498b613185565b9061350f565b90613568565b8152602001611e7a6305f5e100611e4f611e718c600f0b6134fc565b611e4988613185565b905298975050505050505050565b60008111611e9557600080fd5b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316637d8c26596040518163ffffffff1660e01b8152600401600060405180830381600087803b158015611ef057600080fd5b505af1158015611f04573d6000803e3d6000fd5b50506040516311f9fbc960e21b8152600092506001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001691506347e7ef2490611f5c90339060648702906004016144c3565b602060405180830381600087803b158015611f7657600080fd5b505af1158015611f8a573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611fae9190613f4a565b9050611fe56001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016333085612eb7565b336001600160a01b03167f73a19dd210f1a7f902193214c0ee91dd35ee5b4d920cba8d519eca65a7b488ca8284604051610479929190614683565b60608101511580612035575043816060015110155b6120515760405162461bcd60e51b815260040161054790614549565b80516120e0576003546040516354ba0f2760e01b81526001600160a01b03909116906354ba0f2790612087903390600401614467565b602060405180830381600087803b1580156120a157600080fd5b505af11580156120b5573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906120d99190613f4a565b8152612187565b60035481516040516331a9108f60e11b815233926001600160a01b031691636352211e916121119190600401614523565b60206040518083038186803b15801561212957600080fd5b505afa15801561213d573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906121619190613efc565b6001600160a01b0316146121875760405162461bcd60e51b81526004016105479061452c565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316637d8c26596040518163ffffffff1660e01b8152600401600060405180830381600087803b1580156121e257600080fd5b505af11580156121f6573d6000803e3d6000fd5b5060009250829150505b8260200151518110156122d1576122c76122c060046000866000015181526020019081526020016000208560200151848151811061223a57fe5b60200260200101516000015186600001518760200151868151811061225b57fe5b6020026020010151602001518860200151878151811061227757fe5b6020026020010151604001518960200151888151811061229357fe5b6020026020010151606001518a6020015189815181106122af57fe5b602002602001015160800151613201565b83906133ea565b9150600101612200565b5080156123e55760025460405163095ea7b360e01b81526001600160a01b037f000000000000000000000000000000000000000000000000000000000000000081169263095ea7b39261232d92919091169085906004016144c3565b602060405180830381600087803b15801561234757600080fd5b505af115801561235b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061237f9190613f18565b506002546040516301acfa2360e51b81526001600160a01b039091169063359f4460906123b290309085906004016144c3565b600060405180830381600087803b1580156123cc57600080fd5b505af11580156123e0573d6000803e3d6000fd5b505050505b81516000908152600460205260408082209084015173__$b139f62619843504e83620ab3c72958bdd$__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__$b139f62619843504e83620ab3c72958bdd$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'

type PerpetualMarketConstructorParams =
  | [linkLibraryAddresses: PerpetualMarketLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>

const isSuperArgs = (
  xs: PerpetualMarketConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === 'string' ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    '_isInterface' in xs[0]
  )
}

export class PerpetualMarket__factory extends ContractFactory {
  constructor(...args: PerpetualMarketConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args)
    } else {
      const [linkLibraryAddresses, signer] = args
      super(
        _abi,
        PerpetualMarket__factory.linkBytecode(linkLibraryAddresses),
        signer
      )
    }
  }

  static linkBytecode(
    linkLibraryAddresses: PerpetualMarketLibraryAddresses
  ): string {
    let linkedBytecode = _bytecode

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$b139f62619843504e83620ab3c72958bdd\\$__', 'g'),
      linkLibraryAddresses['contracts/lib/TraderVaultLib.sol:TraderVaultLib']
        .replace(/^0x/, '')
        .toLowerCase()
    )

    return linkedBytecode
  }

  deploy(
    _perpetualMarketCoreAddress: string,
    _quoteAsset: string,
    _underlyingAsset: string,
    _feeRecepient: string,
    _vaultNFT: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PerpetualMarket> {
    return super.deploy(
      _perpetualMarketCoreAddress,
      _quoteAsset,
      _underlyingAsset,
      _feeRecepient,
      _vaultNFT,
      overrides || {}
    ) as Promise<PerpetualMarket>
  }
  getDeployTransaction(
    _perpetualMarketCoreAddress: string,
    _quoteAsset: string,
    _underlyingAsset: string,
    _feeRecepient: string,
    _vaultNFT: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _perpetualMarketCoreAddress,
      _quoteAsset,
      _underlyingAsset,
      _feeRecepient,
      _vaultNFT,
      overrides || {}
    )
  }
  attach(address: string): PerpetualMarket {
    return super.attach(address) as PerpetualMarket
  }
  connect(signer: Signer): PerpetualMarket__factory {
    return super.connect(signer) as PerpetualMarket__factory
  }
  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): PerpetualMarketInterface {
    return new utils.Interface(_abi) as PerpetualMarketInterface
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PerpetualMarket {
    return new Contract(address, _abi, signerOrProvider) as PerpetualMarket
  }
}

export interface PerpetualMarketLibraryAddresses {
  ['contracts/lib/TraderVaultLib.sol:TraderVaultLib']: string
}
